/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {useCallback, useState} from 'react';

export interface UseSnackbarResult {
  openSnackbar: (newMessage: string) => void;
  dismissSnackbar: () => void;
  show: boolean;
  message: string;
}

/**
 * Hook that handles opening & dismissing a snackbar displaying a message.
 */
export const useSnackbar = (): UseSnackbarResult => {
  const [show, setShow]       = useState(false);
  const [message, setMessage] = useState('');

  const dismissSnackbar = useCallback(() => {
    setShow(false);
  }, []);

  const openSnackbar = useCallback((newMessage: string) => {
    setMessage(newMessage);
    setShow(true);
  }, []);

  return {
    dismissSnackbar,
    openSnackbar,
    show,
    message
  };
};

export default useSnackbar;
